import React from "react";

import { useNavigate } from "react-router-dom";

import {

    Avatar,
    Badge,
    Button,
    Card,
    Space,
    Tag,
    Typography

} from "antd";

import {

    BellOutlined,
    DollarOutlined,
    MessageOutlined,
    ShoppingCartOutlined,
    TruckOutlined,
    CheckCircleOutlined,
    SolutionOutlined

} from "@ant-design/icons";

import { requestNotificationOf, requestTargetOf } from "./requestNotifications";

const { Text } = Typography;

const iconByType = {

    CONVERSATION: <MessageOutlined />,

    OFFER: <DollarOutlined />,

    AGREEMENT: <CheckCircleOutlined />,

    PAYMENT: <DollarOutlined />,

    ORDER: <ShoppingCartOutlined />,

    DELIVERY: <TruckOutlined />,

    SYSTEM: <BellOutlined />

};

const colorByType = {

    CONVERSATION: "#1890ff",

    OFFER: "#13c2c2",

    AGREEMENT: "#52c41a",

    PAYMENT: "#722ed1",

    ORDER: "#fa8c16",

    DELIVERY: "#eb2f96",

    SYSTEM: "#8c8c8c"

};

const NotificationCard = ({
                              notification,
                              onOpenConversation,
                              onOpenOrder,
                              onMarkAsRead
                          }) => {

    const navigate = useNavigate();

    const request = requestNotificationOf(notification);

    const handleClick = () => {

        if (!notification.read) {

            onMarkAsRead(notification.id);

        }

        // Demandes de prévente / d'achat : page des demandes (acheteur) ou espace entreprise.
        if (request) {

            if (request.path) {
                navigate(requestTargetOf(request, notification));
            } else {
                window.location.assign(request.url);
            }

            return;

        }

        switch (notification.notificationType) {

            case "CONVERSATION":

                onOpenConversation(notification);

                break;

            case "ORDER":
                break;

                case "PAYMENT":
                break;

            case "DELIVERY":

                onOpenOrder(notification);

                break;

            default:

                break;

        }

    };

    return (

        <ListItem
            notification={notification}
            handleClick={handleClick}
            request={request}
        />

    );

};

export default NotificationCard;





function ListItem({

                      notification,

                      handleClick,

                      request

                  }) {

    const color = request ? request.color : colorByType[notification.notificationType];

    const icon = request ? <SolutionOutlined /> : iconByType[notification.notificationType];

    return (

        <Card

            hoverable

            size="small"

            onClick={handleClick}

            style={{

                marginBottom: 12,

                borderRadius: 12,

                cursor: "pointer",

                borderLeft: `4px solid ${color}`

            }}

        >

            <Space
                align="start"
                style={{ width: "100%" }}
            >

                <Badge

                    dot={!notification.read}

                    offset={[-2, 2]}

                >

                    <Avatar

                        size={48}

                        icon={icon}

                        style={{
                            background: color
                        }}

                    />

                </Badge>

                <div
                    style={{
                        flex: 1
                    }}
                >

                    <Space
                        style={{
                            width: "100%",
                            justifyContent: "space-between"
                        }}
                    >

                        <Text
                            strong
                        >
                            {notification.title}
                        </Text>

                        <Tag
                            color={color}
                        >
                            {request ? request.label : notification.notificationType}
                        </Tag>

                    </Space>

                    <div
                        style={{
                            marginTop: 8
                        }}
                    >

                        <Text>

                            {notification.message}

                        </Text>

                    </div>

                    <div
                        style={{
                            marginTop: 10,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >

                        <Text
                            type="secondary"
                            style={{
                                fontSize: 12
                            }}
                        >

                            {new Date(
                                notification.createdAt
                            ).toLocaleString()}

                        </Text>

                        <Button
                            size="small"
                            type="link"
                        >
                            Ouvrir
                        </Button>

                    </div>

                </div>

            </Space>

        </Card>

    );

}